import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";
import Configs from "../../vendorConfigs/Configs";
import { version } from "../../../../package.json"
import GameModel from "../../../core/src/model/GameModel";

export default class ClientConfigRequest implements IRequestBuilder {
    get method() {
      return "POST";
    }
  
    get path() {
      return Configs.vendorServer.clientconfigurl
    }
  
    get requestData() {
      let requestParams = {
        gameref: Configs.vendorServer.gameId,
        partnerid: GameModel.partnerid,
        channel: GameModel.urlParams.channel || "web",
        jurisdiction: GameModel.urlParams.jurisdiction,
        versionstring: `game:${version}`,
        clientversion: GameModel.gameVersion,
      };
  
      return requestParams;
    }
}